import { render } from "./InstanceTab.vue?vue&type=template&id=163a3eb4&scoped=true"
import script from "./InstanceTab.vue?vue&type=script&lang=js"
export * from "./InstanceTab.vue?vue&type=script&lang=js"

import "./InstanceTab.vue?vue&type=style&index=0&id=163a3eb4&lang=scss&scoped=true"
import "./InstanceTab.vue?vue&type=style&index=1&id=163a3eb4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-163a3eb4"]])

export default __exports__